export default () => process.env.GATSBY_URL;
